import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'neutral' | 'success' | 'warning' | 'error' | 'brand';
  className?: string;
}
export function Badge({
  children,
  variant = 'neutral',
  className = ''
}: BadgeProps) {
  const variants = {
    neutral: 'bg-[#ecebea] text-[#080707]',
    success: 'bg-[#b7eb8f] text-[#04844b]',
    warning: 'bg-[#fe9339] text-[#080707]',
    error: 'bg-[#fe5c5c] text-[#3e3e3c]',
    brand: 'bg-[#0176d3] text-white'
  };
  return <span className={`
      inline-flex items-center px-2 py-0.5 rounded text-xs font-bold uppercase tracking-wide
      ${variants[variant]} ${className}
    `} data-id="element-170">
      {children}
    </span>;
}